import { Heading, IconButton, Text, HStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

export namespace DocumentsCenterHeaderTypes {
  export interface Props {
    onGoBack?: () => void;
  }
}

export const DocumentsCenterHeader: React.FC<DocumentsCenterHeaderTypes.Props> = ({ onGoBack }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <HStack alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space="stack.nano">
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={isMobile ? undefined : 3}
          variant={isMobile ? 'unstyled' : 'link'}
          iconColor={isMobile ? 'neutral.dark' : 'brand.tertiary.principal'}
          iconSize="xs"
          padding={{ base: 0, sm: 'inset.nano' }}
          onPress={onGoBack}
        />
        {isMobile ? (
          <Text fontSize="lg" variant="bold">
            Central de Documentos
          </Text>
        ) : (
          <Heading testId="forms-and-terms-heading">Central de Documentos</Heading>
        )}
      </HStack>
    </HStack>
  );
};
